import React from "react";
import { default as WChip } from "@mui/material/Chip";

function Chip(props) {
  return <WChip {...props} />;
}

export default Chip;
